(() => {
  const $ = (s, r=document) => r.querySelector(s);
  const $$ = (s, r=document) => [...r.querySelectorAll(s)];
  const drawer = $('#CartDrawer');
  const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'en-US',{style:'currency',currency:(window.Shopify && Shopify.currency && Shopify.currency.active)||'USD'}).format(cents/100);

  async function renderCart(open=true){
    if(!drawer) return;
    const cart = await fetch('/cart.js').then(r=>r.json());
    $$('[data-cart-count]').forEach(el=>el.textContent=cart.item_count);
    const body=$('[data-cart-drawer-body]',drawer), footer=$('[data-cart-drawer-footer]',drawer);
    if(cart.item_count===0){body.innerHTML='<p>Your cart is empty.</p>';footer.innerHTML='';}
    else{
      body.innerHTML=cart.items.map(item=>`<div class="drawer-line"><img src="${item.image || ''}" alt=""><div><a href="${item.url}"><strong>${item.product_title}</strong></a><div>${item.variant_title && item.variant_title!=='Default Title'?item.variant_title:''}</div><small>Qty ${item.quantity}</small></div><strong>${money(item.final_line_price)}</strong></div>`).join('');
      const threshold=(window.themeSettings&&window.themeSettings.freeShippingThreshold)||75;
      const remain=Math.max(0,threshold*100-cart.total_price); const pct=Math.min(100,(cart.total_price/(threshold*100))*100);
      footer.innerHTML=`<p>${remain>0?`${money(remain)} away from free shipping`:'You unlocked free shipping!'}</p><div class="shipping-progress"><span style="width:${pct}%"></span></div><p>Subtotal <strong>${money(cart.total_price)}</strong></p><a class="button button--full" href="/checkout">CHECKOUT</a><a class="button button--secondary button--full" href="/cart" style="margin-top:8px">VIEW CART</a>`;
    }
    if(open){drawer.classList.add('is-open');drawer.setAttribute('aria-hidden','false');document.body.style.overflow='hidden';}
  }
  function closeCart(){if(!drawer)return;drawer.classList.remove('is-open');drawer.setAttribute('aria-hidden','true');document.body.style.overflow='';}
  document.addEventListener('click', async e=>{
    const open=e.target.closest('[data-cart-open]'); if(open && drawer){e.preventDefault();renderCart(true);}
    if(e.target.closest('[data-cart-close]')) closeCart();
    const menu=e.target.closest('[data-mobile-menu]'); if(menu){const m=$('[data-mobile-drawer]');m.classList.toggle('is-open');m.setAttribute('aria-hidden',m.classList.contains('is-open')?'false':'true');}
  });
  document.addEventListener('change',e=>{

    const currencySelect=e.target.closest('[data-currency-select]');
    if(currencySelect){
      const form=currencySelect.closest('form');
      const hidden=form&&form.querySelector('[data-currency-hidden]');
      if(hidden){ hidden.value=currencySelect.value; if(form.requestSubmit){ form.requestSubmit(); } else { form.submit(); } }
    }
  });
  document.addEventListener('submit',async e=>{
    const form=e.target.closest('.quick-add-form, .product-form'); if(!form || !drawer) return;
    e.preventDefault(); const button=form.querySelector('button[type="submit"]'); if(button) button.disabled=true;
    try{await fetch('/cart/add.js',{method:'POST',headers:{'Accept':'application/json'},body:new FormData(form)}).then(r=>{if(!r.ok)throw new Error('Add to cart failed');return r.json()});await renderCart(true);}catch(err){alert(err.message);}finally{if(button)button.disabled=false;}
  });
  // Only fetch a product card's hover-swap image once the shopper actually hovers/focuses
  // the card, instead of every card loading two full images on every collection/carousel page.
  const loadHoverImage=(media)=>{
    if(!media) return;
    const hoverImg=media.querySelector('[data-hover-image]');
    if(hoverImg && !hoverImg.getAttribute('src') && hoverImg.dataset.hoverSrc){
      hoverImg.src=hoverImg.dataset.hoverSrc;
    }
  };
  document.addEventListener('mouseover',e=>{const media=e.target.closest('.product-card__media');if(media)loadHoverImage(media);});
  document.addEventListener('focusin',e=>{const media=e.target.closest('.product-card__media');if(media)loadHoverImage(media);});

  const swatchColors={
    black:'#111111',white:'#ffffff',ivory:'#f5f0e2',natural:'#e6dcc8',cream:'#efe6d2',sand:'#d4c3a5',beige:'#cdbca0',khaki:'#b8aa87',tan:'#c8a47f',
    grey:'#7a7a7a',gray:'#7a7a7a','dark grey':'#565a5d','dark gray':'#565a5d','dark heather':'#595d63','light grey':'#c7c9cc','light gray':'#c7c9cc',charcoal:'#4a4d52',graphite:'#666a70',granite:'#686b6d',
    navy:'#233552','true navy':'#1c2e4a',midnight:'#283347','heather navy':'#4d5b79',royal:'#2453b8',blue:'#5d84b3','light blue':'#a6bfd9','flo blue':'#7fa3b8','blue jean':'#7797ae','carolina blue':'#8ab3d8',sapphire:'#1d6ecb',indigo:'#384867',denim:'#5f6f86','lagoon blue':'#4f91a0',chambray:'#93aebd','ice blue':'#c3d8e0',nautical:'#3b5b76',sky:'#8fbfd8',storm:'#5a6875',steel:'#75828c',silver:'#c6c9cc','stone wash':'#8d9aa3',stonewash:'#8d9aa3',
    red:'#b91c1c','cardinal red':'#8f1f2e',crimson:'#8f2029',maroon:'#6f263d',burgundy:'#6f263d',brick:'#a94b3c',chili:'#9c3b2e',
    green:'#6d8a73','forest green':'#314d38','irish green':'#1f8b4c',military:'#748265','military green':'#66745f',moss:'#66765b','spanish moss':'#8a8f5c',olive:'#687054',sage:'#97a18b',bay:'#659a96',seafoam:'#9fc1b6',mint:'#a9c9b8','chalky mint':'#a7cdbf','island reef':'#64a8a4',reef:'#64a8a4',spruce:'#3f5a4d',
    orange:'#d58a36',yam:'#c77a45','burnt orange':'#a85424',terracotta:'#b26045',sunset:'#d97a4a','safety orange':'#e2711d',gold:'#c79a33',yellow:'#e4c64d',mustard:'#c9a93a',butter:'#f0dc88',sunflower:'#e0b83a','safety green':'#c7d84a',spice:'#b6672f','sand dune':'#c9b998',
    purple:'#6e5f82',violet:'#7661a6',lavender:'#aea1bd',orchid:'#b497c2',plum:'#5f4058',grape:'#5b4266',
    pink:'#e8c6cf','light pink':'#eed9df','dusty rose':'#c99a9a',pepper:'#4b4c4b',espresso:'#4a372d',brown:'#76533a',chocolate:'#5a4337',
    blossom:'#d9b2af',melon:'#d48b7d',watermelon:'#cf6d6e',berry:'#9a4a57',crunchberry:'#c55f68',heliconia:'#cf3f71',
    ash:'#d5d8db','ash grey':'#d5d8db','athletic heather':'#bfc3c7','sport grey':'#b3b6ba','gravel':'#9ea3a8','smoke':'#7c7f85',
    'cherry tomato':'#d1442b','peach':'#f0b494','powder blue':'#b8d3e0','wine':'#5c1f2e','washed denim':'#7d9bb5','cement':'#c8c8c8'
  };

  const colorKeysByWords=Object.keys(swatchColors).sort((a,b)=>(b.split(' ').length-a.split(' ').length)||(b.length-a.length));
  const matchSwatchColor=(rawName)=>{
    const name=rawName.replace(/\s+/g,' ').trim();
    if(!name) return '';
    if(swatchColors[name]) return swatchColors[name];
    // Multi-color values like "Black/White" or "Navy - Grey": try each side.
    if(/[\/,-]/.test(name)){
      for(const part of name.split(/[\/,-]/).map(p=>p.trim()).filter(Boolean)){
        const hit=matchSwatchColor(part);
        if(hit) return hit;
      }
    }
    const words=name.split(' ');
    // Strip a leading style/SKU prefix word at a time (e.g. "P Sport Grey", "Premium Navy").
    for(let i=1;i<words.length;i++){
      const candidate=words.slice(i).join(' ');
      if(swatchColors[candidate]) return swatchColors[candidate];
    }
    // Strip a trailing noise word at a time (e.g. "Sport Grey Tee").
    for(let i=words.length-1;i>0;i--){
      const candidate=words.slice(0,i).join(' ');
      if(swatchColors[candidate]) return swatchColors[candidate];
    }
    // Any known multi-word color name appearing inside the string.
    for(const key of colorKeysByWords){
      if(key.indexOf(' ')!==-1 && name.indexOf(key)!==-1) return swatchColors[key];
    }
    // Last resort: any single word that matches a known color.
    for(const w of words){
      if(swatchColors[w]) return swatchColors[w];
    }
    return '';
  };

  const applySwatchColors=(section)=>{
    $$('.variant-swatch',section).forEach(label=>{
      const chip=$('.variant-swatch__chip',label);
      const fallback=$('[data-swatch-fallback]',label);
      if(!chip) return;
      const hasImage=!!chip.querySelector('img');
      if(hasImage){chip.style.backgroundColor='';if(fallback)fallback.style.display='none';return;}
      // Respect a real Shopify-configured swatch color, or a merchant CSS override keyed
      // to this exact color name, before falling back to our best-guess color dictionary.
      const nativeColor=getComputedStyle(label).getPropertyValue('--swatch-color').trim();
      if(nativeColor){chip.style.backgroundColor='';if(fallback)fallback.style.display='none';return;}
      const name=(label.dataset.colorName||'').trim().toLowerCase();
      const mapped=matchSwatchColor(name);
      if(mapped){chip.style.backgroundColor=mapped;if(fallback)fallback.style.display='none';}
      else{chip.style.backgroundColor='';if(fallback)fallback.style.display='grid';}
    });
  };

  const updateYouthSizeLabels=(section)=>{
    const styleField=$$('.variant-option',section).find(f=>(f.dataset.optionName||'').toLowerCase().includes('style'));
    const styleChecked=styleField ? $('[data-option-input]:checked',styleField) : null;
    const style=(styleChecked?.value||'').toLowerCase();
    const sizeField=$('.variant-option--size',section);
    if(!sizeField)return;
    const youth=style.includes('youth');
    const map={xs:'YXS',s:'YS',m:'YM',l:'YL',xl:'YXL',yxs:'YXS',ys:'YS',ym:'YM',yl:'YL',yxl:'YXL'};
    $$('[data-size-label]',sizeField).forEach(el=>{const original=(el.dataset.originalSize||el.textContent||'').trim();el.textContent=youth?(map[original.toLowerCase()]||original):original;});
    const selected=$('[data-selected-option]',sizeField),checked=$('[data-option-input]:checked',sizeField);
    if(selected&&checked){const raw=checked.value.trim();selected.textContent=youth?(map[raw.toLowerCase()]||raw):raw;}
  };

  const initProductSection=(section)=>{
    if(!section)return;
    applySwatchColors(section);
    updateYouthSizeLabels(section);
    $$('[data-media-thumb]',section).forEach(t=>{
      if(t.dataset.boundMedia==='true')return;
      t.dataset.boundMedia='true';
      t.addEventListener('click',()=>{
        const id=t.dataset.mediaId;if(!id)return;
        $$('[data-product-media]',section).forEach(m=>{const active=String(m.dataset.mediaId)===String(id);m.hidden=!active;m.classList.toggle('is-active',active)});
        $$('[data-media-thumb]',section).forEach(x=>x.classList.toggle('is-active',String(x.dataset.mediaId)===String(id)));
      });
    });
  };

  const restoreProductInputs=(section,state)=>{
    if(!section||!state)return;
    const personalization=$('.personalization-box textarea',section);if(personalization&&state.personalization!=null)personalization.value=state.personalization;
    const qty=$('.qty-row input[name="quantity"]',section);if(qty&&state.quantity)qty.value=state.quantity;
  };

  const refreshHighVariantProduct=async(input)=>{
    const section=input.closest('[data-product-section]');
    const picker=input.closest('[data-high-variant-picker]');
    if(!section||!picker)return;
    const sectionId=section.dataset.sectionId;
    const optionIds=$$('[data-option-input]:checked',picker).map(el=>el.dataset.optionValueId).filter(Boolean);
    const baseProductUrl=input.dataset.productUrl||section.dataset.productUrl||location.pathname;
    const requestUrl=new URL(baseProductUrl,location.origin);
    requestUrl.searchParams.set('section_id',sectionId);
    if(optionIds.length)requestUrl.searchParams.set('option_values',optionIds.join(','));
    const state={personalization:$('.personalization-box textarea',section)?.value||'',quantity:$('.qty-row input[name="quantity"]',section)?.value||'1'};
    const clickedValueId=input.dataset.optionValueId;
    section.classList.add('is-loading-variant');
    try{
      const response=await fetch(requestUrl.toString(),{headers:{'X-Requested-With':'XMLHttpRequest'}});
      if(!response.ok)throw new Error('Unable to load this option combination.');
      const text=await response.text();
      const doc=new DOMParser().parseFromString(text,'text/html');
      const nextSection=doc.querySelector('[data-product-section]');
      if(!nextSection)throw new Error('Product options could not be refreshed.');
      const oldModal=document.querySelector('[data-size-chart-modal]');
      const nextModal=doc.querySelector('[data-size-chart-modal]');
      section.replaceWith(nextSection);
      if(oldModal&&nextModal)oldModal.replaceWith(nextModal);
      restoreProductInputs(nextSection,state);
      initProductSection(nextSection);

      // If a downstream selected value is no longer valid after changing Style/Color,
      // select the first server-approved value and refresh once more.
      const invalidSelected=$$('[data-option-input]:checked',nextSection).find(el=>el.disabled);
      if(invalidSelected){
        const field=invalidSelected.closest('.variant-option');
        const firstValid=field&&$('[data-option-input]:not(:disabled)',field);
        if(firstValid){firstValid.checked=true;return refreshHighVariantProduct(firstValid);}
      }

      const displayUrl=new URL(baseProductUrl,location.origin);
      if(optionIds.length)displayUrl.searchParams.set('option_values',optionIds.join(','));
      history.replaceState({},'',displayUrl.pathname+displayUrl.search);
      const focusTarget=clickedValueId&&nextSection.querySelector(`[data-option-value-id="${clickedValueId}"]`);
      if(focusTarget)focusTarget.focus({preventScroll:true});
    }catch(err){
      console.error(err);
      alert(err.message||'Unable to update product options. Please try again.');
      section.classList.remove('is-loading-variant');
    }
  };

  $$('.product-v2').forEach(initProductSection);

  document.addEventListener('change',e=>{
    const input=e.target.closest('[data-high-variant-picker] [data-option-input]');
    if(input)refreshHighVariantProduct(input);
  });

  document.addEventListener('click',e=>{
    const open=e.target.closest('[data-size-chart-open]');
    if(open){
      e.preventDefault();
      const productSection=open.closest('.product-v2');
      const modal=productSection ? productSection.nextElementSibling : document.querySelector('[data-size-chart-modal]');
      const target=(modal && modal.matches('[data-size-chart-modal]')) ? modal : document.querySelector('[data-size-chart-modal]');
      if(target){
        target.classList.add('is-open');target.setAttribute('aria-hidden','false');document.body.style.overflow='hidden';
        const styleField=productSection && [...productSection.querySelectorAll('.variant-option')].find(f=>(f.dataset.optionName||'').toLowerCase().includes('style'));
        const styleValue=styleField?.querySelector('[data-option-input]:checked')?.value?.toLowerCase()||'';
        let tab='basic';
        if(styleValue.includes('shaka'))tab='shaka';else if(styleValue.includes('comfort')||styleValue.includes('1717')||styleValue.includes('c17'))tab='comfort';else if(styleValue.includes('heavyweight')||styleValue.includes('garment'))tab='shaka';else if(styleValue.includes('premium'))tab='premium';else if(styleValue.includes('woman')||styleValue.includes('women'))tab='women';else if(styleValue.includes('hood'))tab='hoodie';else if(styleValue.includes('sweat'))tab='sweatshirt';else if(styleValue.includes('v-neck')||styleValue.includes('v neck'))tab='vneck';else if(styleValue.includes('youth'))tab='youth';
        target.querySelectorAll('[data-size-tab]').forEach(b=>b.classList.toggle('is-active',b.dataset.sizeTab===tab));
        target.querySelectorAll('[data-size-panel]').forEach(p=>p.classList.toggle('is-active',p.dataset.sizePanel===tab));
      }
    }
    if(e.target.closest('[data-size-chart-close]')){
      const modal=e.target.closest('[data-size-chart-modal]');if(modal){modal.classList.remove('is-open');modal.setAttribute('aria-hidden','true');document.body.style.overflow='';}
    }
    const tab=e.target.closest('[data-size-tab]');
    if(tab){
      const modal=tab.closest('[data-size-chart-modal]');
      modal.querySelectorAll('[data-size-tab]').forEach(b=>b.classList.toggle('is-active',b===tab));
      modal.querySelectorAll('[data-size-panel]').forEach(p=>p.classList.toggle('is-active',p.dataset.sizePanel===tab.dataset.sizeTab));
    }
  });

  // Homepage / collection product carousels (arrow buttons + scroll-snap track)
  const updateCarouselArrows=(track)=>{
    const wrap=track.closest('.carousel-section, .section');
    if(!wrap)return;
    const prevBtn=$(`[data-carousel-prev="${track.id}"]`,wrap);
    const nextBtn=$(`[data-carousel-next="${track.id}"]`,wrap);
    const max=track.scrollWidth-track.clientWidth-2;
    if(prevBtn)prevBtn.disabled=track.scrollLeft<=0;
    if(nextBtn)nextBtn.disabled=track.scrollLeft>=max;
  };
  const scrollCarousel=(id,dir)=>{
    const track=document.getElementById(id);
    if(!track)return;
    const amount=Math.max(track.clientWidth*0.9,240)*dir;
    track.scrollBy({left:amount,behavior:'smooth'});
    setTimeout(()=>updateCarouselArrows(track),350);
  };
  document.addEventListener('click',e=>{
    const prev=e.target.closest('[data-carousel-prev]'); if(prev){scrollCarousel(prev.dataset.carouselPrev,-1);}
    const next=e.target.closest('[data-carousel-next]'); if(next){scrollCarousel(next.dataset.carouselNext,1);}
  });
  $$('[data-carousel]').forEach(track=>{
    updateCarouselArrows(track);
    track.addEventListener('scroll',()=>updateCarouselArrows(track),{passive:true});
    window.addEventListener('resize',()=>updateCarouselArrows(track));
  });

})();
